<template>
    <div>
        <ElementsTooltipSingleton
            :ref="(el)=>{ loadTooltipElementReady(el); }"
        />
        <div class="flex flex-col gap-2 w-[540px]">
            <div class="font-body-sm-semibold">
                Copy(cc)
            </div>
            <template v-for="(referenceItem, index) in referenceList" :key="index">
                <div class="flex gap-2 items-center ">
                    <div
                        class="flex-none rounded-04 bg-background-basic-2 p-4 flex gap-2 items-center"
                        :class="containerWidth"
                    >
                        <div class="font-caption-md-semibold w-14 shrink-0">
                            Copy(cc)
                        </div>
                        <div
                            class="flex h-9 p-2 rounded-02 justify-between items-center gap-1 bg-background-basic-1 border border-border-basic-2 flex-1"
                            :class="referenceItem.error 
                                ? 'border-accent-red-3' 
                                : 'border-border-basic-2'"
                            style="cursor:pointer"
                            @click="openSelectReferencePopup(index)"
                        >
                            <span
                                class="text-left text-xs truncate flex-1"
                                :class="{ 'text-content-basic-3': !referenceItem?.referenceTarget?.referenceType }"
                            >
                                {{ nameDisplay(referenceItem) }}
                            </span>
                            <button v-show="!disabled">
                                <userIcon width="16" height="16" weight="THIN" color="text-primary-3"/>
                            </button>
                        </div>
                        <!-- design-approve-process.vue 와 동일하게 레이아웃 잡으려고 넣은 코드로 기능은 사용하지 않음 -->
                        <ElementsToggle
                            class="opacity-0 pointer-events-none"
                            labelClass="text-xs leading-[17px] mr-1"
                            v-model="referenceItem.autoApprovedYn"
                            :toggleLabel="'Automatic\nApproval'"
                            :useStringValueObj="toggleYesOrNoOptions"
                            :disabled="true"
                        />
                    </div>
                    <button  
                        v-show="!disabled" @click="deleteProcessStep(index)"
                        class="h-full" :ref=" (el) => { loadTooltip(el, () => { return 'Delete'; }); }">
                        <deleteIcon width="24" height="24" weight="THIN" color="text-content-basic-3"/>
                    </button>
                </div>
                <div
                    v-if="referenceItem.error"
                    class="c_alert_message" 
                >
                    Please add a user to receive a copy of this request
                </div>
            </template>
            <DesignButton
                v-if="!disabled"
                v-show="referenceList.length < maxReferenceCount"
                @click="addReferenceStep"
                btnSize="SM"
                btnType="SECONDARY"
                btnVariant="BORDER"
                btnText="Add"
                :class="[containerWidth, 'border-border-basic-1']"
            >
                <template #front-icon>
                    <AddIcon :width="16" :height="16" color="text-content-basic-1" weight="THIN" />
                </template>
            </DesignButton>
        </div>

        <!--Select CC recipients Modal START-->
        <Teleport to="body">
			<AppPopup
				v-model="showMemberAssignment"
				name="Select CC recipients"
				:noneOverflowAuto="false"
				:maxWidth="'600px'"
				@afterClose="closeSelectReferencePopup"
			>
                <!-- Level Heads Section -->
                <div class="level-heads-section flex flex-col gap-2.5 p-5">
                    <div class="font-body-md-semibold">Head</div>
                    <div class="w-full flex flex-col gap-1.5 font-body-sm-medium text-content-inverse-1">
                        <div class="flex items-center gap-4">
                            <div
                                class="flex items-center justify-center gap-2 px-5 py-2 bg-accent-red-3 max-w-[240px] w-full h-[2.25rem] rounded-01 cursor-pointer"
                                :class="{ 'ring-2 ring-primary-3 ring-offset-2': isSelected('FIRST_HEAD') }"
                                @click="selectReference('FIRST_HEAD', null, 'Level 1 Head')"
                            >
                                <PersonAddIcon :width="16" :height="16" color="text-content-inverse-1" weight="FILL" />
                                Level 1 Head
                            </div>
                            <CheckIcon v-if="isSelected('FIRST_HEAD')" :width="24" :height="24" color="text-primary-3" weight="REGULAR" />
                        </div>

                        <div class="flex items-center gap-4">
                            <div
                                class="flex items-center justify-center gap-2 px-5 py-2 bg-accent-lightblue-3 max-w-[240px] w-full h-[2.25rem] rounded-01 cursor-pointer"
                                :class="{ 'ring-2 ring-primary-3 ring-offset-2': isSelected('SECOND_HEAD') }"
                                @click="selectReference('SECOND_HEAD', null, 'Level 2 Head')"
                            >
                                <PersonAddIcon :width="16" :height="16" color="text-content-inverse-1" weight="FILL" />
                                Level 2 Head
                            </div>
                            <CheckIcon v-if="isSelected('SECOND_HEAD')" :width="24" :height="24" color="text-primary-3" weight="REGULAR" />
                        </div>

                        <div class="flex items-center gap-4">
                            <div
                                class="flex items-center justify-center gap-2 px-5 py-2 bg-accent-green-3 max-w-[240px] w-full h-[2.25rem] rounded-01 cursor-pointer"
                                :class="{ 'ring-2 ring-primary-3 ring-offset-2': isSelected('THIRD_HEAD') }"
                                @click="selectReference('THIRD_HEAD', null, 'Level 3 Head')"
                            >
                                <PersonAddIcon :width="16" :height="16" color="text-content-inverse-1" weight="FILL" />
                                Level 3 Head
                            </div>
                            <CheckIcon v-if="isSelected('THIRD_HEAD')" :width="24" :height="24" color="text-primary-3" weight="REGULAR" />
                        </div>
                    </div>
                </div>

                <!--line-->
                <div class="flex justify-center px-5 mt-3 mb-7">
                    <div class="w-full h-[1px] bg-background-basic-3"></div>
                </div>

                <!--Search-->
                <div class="flex items-center px-5 gap-2">
                    <DesignDropdownSelect
                        v-model="selectedDepartment"
                        :options="departmentsList"
                        placeholder="Department"
                        :useDefaultMsg="true"
                        size="MD"
                        :width="'w-40'"
                        @change="getEmployeeListBySearch"
                    />
                    <DesignSearchInput
                        v-model="nameForSearch"
                        :options="employeeOptions"
                        width="w-80"
                        placeholder="Search name"
                        size="MD"
                        @searchEvent="getEmployeeListBySearch"
                        ref="employeeSearchBar"
                        :optionClickEvent="true"
                    />
                </div>

                <!--Search result-->
                <div class="employees_container flex-1 overflow-auto ds-scrollbar px-5 mt-4 pb-8">
                    <div class="font-body-md-semibold my-2">Employees</div>
                    <ul class="mb-2">
                        <template v-for="employee in employeeLists" :key="employee.employeeSeq">
                            <li class="px-2 py-3 bg-background-basic-1 hover:bg-background-basic-2">
                                <button
                                    @click="selectReference('USER', employee.employeeSeq, employee.employeeName)"
                                    class="group w-full flex items-start text-left"
                                >
                                    <div class="grid grid-cols-[20px,1fr,24px] gap-2">
                                        <div class="self-start mt-2">
                                            <StatusCircle :status-code="employee.employeeStatus" />
                                        </div>
                                        <div class="min-w-0 w-full">
                                            <div class="font-body-md-regular"
                                                :class="{
                                                    'text-primary-3': isSelected('USER', employee.employeeSeq),
                                                    'text-content-basic-1': !isSelected('USER', employee.employeeSeq)
                                                }"
                                            >
                                                {{ employee.employeeName }}
                                            </div>
                                            <div class="font-body-sm-regular text-content-basic-2">
                                                {{ employee.departmentName || '' }}
                                            </div>
                                        </div>
                                        <div v-if="isSelected('USER', employee.employeeSeq)">
                                            <CheckIcon :width="24" :height="24" color="text-primary-3" weight="REGULAR" />
                                        </div>
                                    </div>
                                </button>
                            </li>
                        </template>
                    </ul>
                    <div class="p-3 flex items-center gap-2 bg-background-basic-3 rounded-3">
                        <ErrorIcon :width="20" :height="20" color="text-content-basic-2" weight="REGULAR" />
                        <span class="font-body-sm-regular text-content-basic-2">
                            Maximum 10 employees are displayed.
                        </span>
                    </div>
                </div>
                <div class="sticky bottom-0 shrink-0 bg-background-basic-1 border-t border-border-basic-2 px-7 py-4">
                    <div class="flex items-center gap-4">
                        <p v-if="referenceAddError" class="c_alert_message">
                            {{ referenceAddErrorMessage }}
                        </p>
                        <DesignButton
                            btnText="Add"
                            btnSize="MD"
                            btnType="PRIMARY"
                            :btnDisabled="false"
                            class="w-[84px] ml-auto"
                            @click="addReference"
                        />
                    </div>
                </div>
            </AppPopup>
		</Teleport>
    </div>
</template>

<style scoped>
.employees_container li+li{
    border-top: 1px solid #ececec;
}
</style>

<script>
import { ValidateUtil } from "@/plugins/app-util.js";
import StatusCircle from '@/components/employee/status-circle/status-circle';
import PersonAddIcon from '@/components/design-system/icon/person-add.vue';
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import DesignSearchInput from '@/components/design-system/design-search-input.vue';
import DesignButton from '@/components/design-system/design-button.vue';
import AddIcon from '@/components/design-system/icon/add.vue';
import ErrorIcon from '@/components/design-system/icon/error.vue';
import CheckIcon from '@/components/design-system/icon/check.vue';
import userIcon from '@/components/design-system/icon/filing/user.vue';
import deleteIcon from '@/components/design-system/icon/delete.vue';
import ElementsToggle from '@/components/elements/ElementsToggle.vue';

export default {
    components: {
        StatusCircle,
        PersonAddIcon,
        DesignDropdownSelect,
        DesignSearchInput,
        DesignButton,
        AddIcon,
        ErrorIcon,
        CheckIcon,
        userIcon,
        deleteIcon,
        ElementsToggle,
    },
    props : {
        disabled : {
            type : Boolean,
            default : false
        },
        containerWidth: {
            type: String,
            default: 'w-[510px]',
        },
    },
    mounted(){
        const self = this;
        self.getDepartmentOptions();
        self.getEmployeeOptions();
    },
    data() {
        return {
            departmentsList: [],
            employeeOptions: [],
            departmentNameBySeq: {},
            showMemberAssignment: false,
            selectedDepartment: null,
            nameForSearch: null,
            employeeLists: [],
            referenceList: [],
            referenceIndex: null,
            toggleYesOrNoOptions: { true: 'Y', false: 'N' },
            maxReferenceCount: 20,
            selectedReference: {
                referenceType: null,
                employeeSeq: null,
                employeeName: null,
            },
            referenceAddError: false,
            referenceAddErrorMessage: '',
            scrollYBackup: 0,
        }
    },
    computed: {
        // 여기에 모달이 더 있으면 || 로 추가
        isAnyPopupOpen() {
            return this.showMemberAssignment;
        },
    },
    watch: {
        isAnyPopupOpen(val) {
            if (val) {
                this.lockBodyScroll();
            } else {
                this.unlockBodyScroll();
            }
        },
    },
    methods : {
        lockBodyScroll() {
            // 현재 스크롤 위치 저장
            this.scrollYBackup = window.scrollY || document.documentElement.scrollTop || 0;

            // 레이아웃 점프 방지 및 스크롤 잠금
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.scrollYBackup}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden'; // 보조(데스크톱)
        },
        unlockBodyScroll() {
            // 원복
            const y = this.scrollYBackup || 0;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.width = '';
            document.body.style.overflow = '';

            // 저장해 둔 위치로 복귀
            window.scrollTo(0, y);
        },
        // -----------------------------------------------------------------------------
        loadTooltip(ele, msgFn, options ){
            this.__tooltipComponent__hidden__.loadBasic(ele, msgFn, options);
        },
        loadTooltipElementReady(ele){
            if( ele == null ) return; // auto-reload, so element can be null sometime.
            this.__tooltipComponent__hidden__ = ele;
        },
        // -----------------------------------------------------------------------------
        over15CharFromFullName : ValidateUtil.over15CharFromFullName,
        openSelectReferencePopup(index) {
            this.resetReferenceModalState();
            this.showMemberAssignment = true;
            this.referenceIndex = index;
        },
        closeSelectReferencePopup() {
            this.referenceIndex = null;
            this.resetReferenceModalState();
            this.showMemberAssignment = false;
        },
        resetReferenceModalState() {
            const self = this;

            // 검색 조건 초기화
            self.selectedDepartment = null;
            self.nameForSearch = null;

            // 선택 상태 초기화
            self.selectedReference = {
                referenceType: null,
                employeeSeq: null,
                employeeName: null,
            };

            // 에러 초기화
            self.resetReferenceAddError();

            // 검색 결과 초기화
            self.employeeLists = [];

            // 검색창 초기화
            if (self.$refs.employeeSearchBar?.clearInput) {
                self.$refs.employeeSearchBar.clearInput();
            }
        },
        resetReferenceAddError() {
            const self = this;
            self.referenceAddError = false;
            self.referenceAddErrorMessage = '';
        },
        addReferenceStep(){
            const self = this;
            if( self.referenceList.length == self.maxReferenceCount ) {
                return;
            }
            self.referenceList.push( { referenceTarget : {} } )
		},
        getDepartmentOptions(){
            const self = this;
            const url = self.$api('uri', 'get-department')
            const json_query = JSON.stringify({
                showRootNode: true,
                menuAccessLevelCode: 'ATTENDANCE_ACCESS_LEVEL',
            });
            self.$axios.get(url, { params : { json_query }}).then(res => {
                self.departmentsList = res.data.data.list.map( dep => ({
                    text : dep.departmentName,
                    value : dep.departmentSeq
                }))

                self.departmentNameBySeq = self.departmentsList.reduce( ( list , department ) => ({
                    ...list, [department.value] : department.text
                }), {} )
            });
        },
        getEmployeeOptions(){
            const self = this;

            const url = self.$api("uri", "get-employee-all")
            self.$axios
                .get(url)
                .then((res) => {
                    self.employeeOptions = res.data.data.list.map( emp => (
                        { text : emp.employeeName, value : emp.employeeSeq}
                    ))
                })
                .catch((err) => {
                    console.error('err : ',err);
                })
        },
        getEmployeeListBySearch(){
            const self = this;
            const url = self.$api("uri", "get-employee-exclude-status-resigned");

            const searchedValues = self.$refs.employeeSearchBar.getSearchedValues();

            let json_query = {
                limit : 10,
                offset : 0,
                departmentSeq : self.selectedDepartment,
                // employeeStatus : null,
                employeeSeqList : searchedValues,
                jobTitleSeq : null,
            }
            json_query = JSON.stringify(json_query);
            self.$axios.get(url, { params : { json_query } }).then(res => {
                self.employeeLists = res.data.data.list;
                self.employeeLists.forEach( employee => {
                    employee.departmentName = self.departmentNameBySeq[employee.departmentSeq];
                })
            });
        },
        deleteProcessStep( processIndex ){
            const self = this;
            // if( self.referenceList.length == 1 ) {
            //     delete self.referenceList[0].error;
            //     self.referenceList[0].referenceTarget = {};
            //     return;
            // }
            self.referenceList.splice( processIndex, 1 );
        },
        selectReference(referenceType, employeeSeq, employeeName) {
            const self = this;
            self.resetReferenceAddError();
            self.selectedReference = { referenceType, employeeSeq, employeeName };
        },
        isSelected(type, seq = null) {
            const self = this;
            if (!self.selectedReference) return false;
            if (self.selectedReference.referenceType !== type) return false;
            if (type === 'USER') {
                return self.selectedReference.employeeSeq === seq;
            }
            return true;
        },
        addReference() {
            const self = this;
            const selectedCC = self.selectedReference;
            if (!selectedCC || !selectedCC.referenceType || (selectedCC.referenceType === 'USER' && !selectedCC.employeeSeq)) {
                self.referenceAddError = true;
                self.referenceAddErrorMessage = 'Please select at least one CC.';
                return;
            }

            const dupIndex = self.findDuplicateReference(selectedCC, self.referenceIndex);
            if (dupIndex !== -1) {
                self.referenceAddError = true;
                self.referenceAddErrorMessage = 'This user is already selected in the CC list.';
                return;
            }

            // Add CC
            const { referenceType, employeeSeq, employeeName } = selectedCC;
            self.referenceList[self.referenceIndex].referenceTarget = { referenceType, employeeSeq, employeeName };

            self.closeSelectReferencePopup();
        },
        findDuplicateReference(selected, excludeIndex) {
            if (!selected?.referenceType) return -1;

            const selectType = selected.referenceType;
            const selectedEmployeeSeq = selected.employeeSeq;

            for (let i = 0; i < this.referenceList.length; i++) {
                if (i === excludeIndex) continue;

                const target = this.referenceList[i]?.referenceTarget || {};
                const type = target.referenceType;

                if (!type) continue;
                if (selectType !== type) continue;
                if (selectType === 'USER') {
                    const employeeSeq = target.employeeSeq;
                    if (selectedEmployeeSeq !== employeeSeq) continue;
                }
                return i;
            }
            return -1;
        },
        checkValidation(){
            const self = this;
            let isValid = true;

            self.referenceList.forEach( ( process, index ) => {
                process.referenceStageOrder = index;
                delete process.error;

                if( !process.referenceTarget.referenceType ){
                    process.error = true;
                    isValid =  false;
                }
            })
            return isValid;
        },
        getReferenceProcessForAxios(){
            const self = this;
            const referenceProcess = self.referenceList.map(process => {
                const { referenceStageOrder, referenceTarget : { referenceType, employeeSeq }} = process;
                // delete referenceTarget.employeeName;
                return { referenceStageOrder, referenceType, employeeSeq,};
            });
            return referenceProcess;
        },
        getReferenceListFromDb( processItem ){
            const self = this;
            if( processItem.length < 1 ) return [{  referenceTarget : {} }];

            const referenceList = processItem.map( process => {
                const {referenceType, employeeSeq, employeeName } = process
                return { referenceTarget : { referenceType, employeeSeq, employeeName } }
            });

            self.referenceList = referenceList;
        },
        resetReferenceProcess() {
            const self = this;
            self.referenceList = [];
            self.referenceIndex = null;
        },
        nameDisplay(item){
            const referenceType = item?.referenceTarget?.referenceType;
            if( referenceType == 'USER' ){
                return item.referenceTarget.employeeName;
            }
            if( referenceType == 'FIRST_HEAD' ){
                return 'Level 1 Head'
            }
            if( referenceType == 'SECOND_HEAD' ){
                return 'Level 2 Head'
            }
            if( referenceType == 'THIRD_HEAD' ){
                return 'Level 3 Head'
            }
            return 'Select Employees';
        }
    }
}
</script>